import * as Actions from "./actions.ts";
import store from "../../../storeInstance";

export function log(...args) {
  store.dispatch(Actions.log.apply(null, args));
}

export function error(...args) {
  store.dispatch(Actions.error.apply(null, args));
}
